import AddRowWithColumn from "./AddRowWithColumn";
import { Droppable } from "@hello-pangea/dnd";
import { useState } from "react";
import BlockDialog from "../../Dialogs/BlockDialog";

export default function AddRowWithField(props) {
  const [isOpen, setOpen] = useState(false);
  return (
    <>
     {isOpen &&
        <BlockDialog
          setOpen={setOpen}
          isOpen={isOpen}
          uiBlocks={props.uiBlocks}
          setBuildArea={props.setBuildArea}
          buildArea={props.buildArea}
          setUiBlocks={props.setUiBlocks}
          count={props.count}
          fieldToMake={2} // 2 - ROW
        />}
      <Droppable
        key={`addRow-${props.count}`}
        droppableId={`addRow-${props.count}`}
        direction="vertical"
        type="field"
      >
        {(provided, snapshot) => {
          return (
            <div
              ref={provided.innerRef}
              className={`plusRow ${snapshot.isDraggingOver ? "draggingOver" : ""
                }`}
              {...provided.droppableProps}
              onClick={() => setOpen(true)}
            >
              <AddRowWithColumn buildArea={props.buildArea} count={props.count} />
            </div>
          );
        }}
      </Droppable>
    </>
  );
}
